import React from 'react';

const Anchor = ({ href, rel, target, children }) => (
  <a href={href} rel={rel} target={target}>
    {children}
  </a>
);

export default Anchor;